/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Vaccine Scheduling View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './VaccineSchedulingView';

export const mapStateToPropsVaccineScheduling = mapStateToProps;
export const mapDispatchToPropsVaccineScheduling = mapDispatchToProps;

export default connect(
  mapStateToPropsVaccineScheduling,
  mapDispatchToPropsVaccineScheduling
)(View);
